import { createSelector } from 'reselect';

const containerSelector = createSelector([
  (store) => store.apps.jobs,
  (store, props) => props.match.params.username,
  (store, props) => props.isOpenSauceUser,
  (store) => store.user,
],
(jobs, username, isOpenSauceUser, user) => ({
  isManualJobsListEmpty: jobs.flatManual.get('manual')?.size === 0,
  isOpenSauceUser: isOpenSauceUser || !user.isAuthenticated(),
  username: username || jobs.users.get('user').username,
}));

const manualJobsSelector = createSelector([
  (store) => store.apps.jobs,
],
(jobs) => ({
  manual: jobs.flatManual.get('manual'),
  manualLoading: jobs.flatManual.get('manualLoading'),
}));

export default containerSelector;
export { containerSelector, manualJobsSelector };
